import { makeStyles, Theme } from '@material-ui/core';
import themes from 'constants/themes';

export const searchConsumerStyles = makeStyles<Theme>(() => ({
    sortWrap: {
        marginTop: 20,
    },
    searchWrap: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: '0',
        marginBottom: '8px',
        boxSizing: 'border-box',
        width: '100%',
    },

    searchIcon: {
        color: themes.palette.primary.main,
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    input: {
        width: '100%',
        marginBottom: '16px',
        '& .MuiInputBase-root': {
            padding: '6px 0',
        },
        '& .MuiInput-underline': {
            '&.Mui-focused': {
                bottom: 0,
                borderBottom: 'none',
            },
            '&:before': {
                borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
        '&.Mui-focused::before': {
            borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
        },
        '& input.MuiInputBase-input': {
            fontFamily: 'PoppinsRegular',
            fontSize: 16,
            fontWeight: 400,
            '&::placeholder': {
                color: `${themes.palette.primary.main}`,
            },
        },
        padding: '3px 0 3px 24px',
        background: 'transparent',
        border: 'none',
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
        color: themes.palette.primary.main,
        fontSize: 14,
        position: 'relative',
        borderRadius: 0,
        outline: 'none !important',
    },
    label: {
        fontSize: '14px',
    },
    searchBox: {
        marginTop: 22,
        paddingBottom: 10,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    buttonPublishBox: {
        position: 'fixed',
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        right: 0,
        zIndex: 100,
        bottom: 0,
        padding: 24,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    buttonPublish: {
        width: '100%',
        height: '48px',
        padding: '0',
        textAlign: 'center',
        color: '#1D474F',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'Graphik',
        background: '#FFFFFF',
        border: '1px solid #4A6C72',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:disabled': {
            backgroundColor: '#b5b5b5',
        },
    },
    selectedOptions: {
        overflowY: 'scroll',
    },
    selectedOptionItem: {
        display: 'flex',
        paddingBottom: 12,
        alignItems: 'center',
    },
    selectedOptionTitle: {
        color: '#1D474F',
        fontSize: 14,
        flex: 1,
        paddingLeft: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));
